export * from "./slider.component"